import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4401Model } from '../kymw4401.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページ情報コピーサービス
 * @export CopyPageInfoService
 * @class CopyPageInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CopyPageInfoService extends PlessJsonResponderSub<null> {
  model: KYMW4401Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CopyPageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCodeOrigin,
        MediumType: this.model.mediumType,
        CoopCode: this.model.coopCode,
        CopyOrderCodeFrom: this.model.orderCodeFromCopy,
        CopyOrderCodeTo: this.model.orderCodeToCopy,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof CopyPageInfoService
   */
  execute(model: KYMW4401Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('copyPageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof CopyPageInfoService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
